<template>
  <div class="feedback-item" @click="$emit('update', value)">
    <component class="feedback-smiley"
               :is="component" />
  </div>
</template>
<script lang="ts" setup>

defineProps<{
  value: number
  component: any
  borderColor: string,
  backgroundColor: string
}>();

defineEmits(['update']);

</script>
<style lang="scss">
.feedback-item {
  display: flex;
  border-radius: 50%;
  align-self: start;
  padding: 8px;
  height: 100%;
  max-width: 64px;
  background-color: v-bind(backgroundColor);

  &.deselected {
      background-color: var(--pidz-grey-light);
    }

  &.selected {
    border-width: 2px;
    border-style: solid;
    border-color: v-bind(borderColor);
    padding: 6px;
  }

  .feedback-smiley {
    height: auto;
    width: auto;
    border-radius: 50%;
  }
}
</style>
